import { render, staticRenderFns } from "./mainjobfair.vue?vue&type=template&id=21945ad6&scoped=true&"
import script from "./mainjobfair.vue?vue&type=script&lang=js&"
export * from "./mainjobfair.vue?vue&type=script&lang=js&"
import style0 from "./mainjobfair.vue?vue&type=style&index=0&id=21945ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21945ad6",
  null
  
)

export default component.exports